import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { provideIonicAngular } from '@ionic/angular/standalone';
import { Drivers } from '@ionic/storage';
import { IonicStorageModule } from '@ionic/storage-angular';

import { httpInterceptorProviders } from '../interceptors';
import { AppInitService, CapacitiesService, RouterNavigationService } from '../services';

export const initializeApp = (appInitService: AppInitService, routerNavigationService: RouterNavigationService): () => Promise<void> => (): Promise<void> => appInitService.init();

export const createAppSharedConfig = (
  isMobile: boolean,
  storageDriverOrder: string[] = [Drivers.IndexedDB]
): ApplicationConfig => ({
  providers: [
    provideIonicAngular({ mode: 'ios', innerHTMLTemplatesEnabled: true }),
    importProvidersFrom(IonicStorageModule.forRoot({
      driverOrder: storageDriverOrder
    })),
    importProvidersFrom(TranslateModule.forRoot()),
    provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json'
    }),
    provideHttpClient(withInterceptors(httpInterceptorProviders)),
    provideAppInitializer(() => {
      const capacitiesService = inject(CapacitiesService);
      capacitiesService.isMobile = isMobile;
      const initializerFn = (initializeApp)(inject(AppInitService), inject(RouterNavigationService));
      return initializerFn();
    })
  ]
});
